export const en = {
  // Navigation
  explore: 'Explore',
  search: 'Search',
  create: 'Create Post',
  messages: 'Messages',
  notifications: 'Notifications',
  settings: 'Settings',
  profile: 'Profile',
  logout: 'Logout',
  home: 'Home',
  
  // Authentication
  signin: 'Sign In',
  signup: 'Sign Up',
  login: 'Login',
  register: 'Register',
  email: 'Email',
  password: 'Password',
  confirmPassword: 'Confirm Password',
  firstName: 'First Name',
  lastName: 'Last Name',
  forgotPassword: 'Forgot Password?',
  alreadyHaveAccount: 'Already have an account? Sign in',
  dontHaveAccount: "Don't have an account? Sign Up",
  
  // Posts & Content
  recent: 'Recent',
  trending: 'Trending',
  popular: 'Popular',
  like: 'Like',
  likes: 'Likes',
  comment: 'Comment',
  comments: 'Comments',
  share: 'Share',
  delete: 'Delete',
  edit: 'Edit',
  post: 'Post',
  posts: 'Posts',
  title: 'Title',
  content: 'Content',
  tags: 'Tags',
  noBlogsFound: 'No blogs found. Try searching for something else or create the first one!',
  
  // AI Assistant
  aiAssistant: 'AI Assistant',
  quickActions: 'Quick Actions',
  writeCaption: 'WRITE A CAPTION',
  suggestTopics: 'SUGGEST TOPICS',
  improveContent: 'IMPROVE CONTENT',
  creativeIdeas: 'CREATIVE IDEAS',
  clearChat: 'CLEAR CHAT',
  aiWritingAssistant: 'AI Writing Assistant',
  poweredByGroq: 'Powered by GROQ AI',
  aiGreeting: 'Hi! I\'m your AI writing assistant. I can help you create engaging content, write captions, suggest post topics, and improve your writing. What would you like to work on today?',
  askMeToHelp: 'Ask me to help with content, captions, topics, or writing...',
  aiThinking: 'AI is thinking...',
  aiAssistantFunctionalityComingSoon: 'AI Assistant functionality coming soon...',
  
  // Chat & Messages
  chat: 'Chat',
  noConversationsYet: 'No conversations yet',
  ideafluxChat: 'IdeaFlux Chat',
  typeMessage: 'Type a message...',
  sendMessage: 'Send Message',
  connectingToChat: 'Connecting to chat...',
  chatFunctionalityComingSoon: 'Chat functionality coming soon...',
  
  // Notifications
  noNotificationsYet: 'No notifications yet.',
  markAllRead: 'Mark All Read',
  clearAll: 'Clear All',
  notificationsFunctionalityComingSoon: 'Notifications functionality coming soon...',
  
  // Settings
  accountSettings: 'Account Settings',
  displayName: 'Display Name',
  emailAddress: 'Email Address',
  languagePreference: 'Language Preference',
  privacySecurity: 'Privacy & Security',
  notificationPreferences: 'Notification Preferences',
  allowDirectMessages: 'Allow Direct Messages',
  letOthersMessage: 'Let other users send you private messages',
  likesOnPosts: 'Likes on posts',
  commentsOnPosts: 'Comments on posts',
  newFollowers: 'New followers',
  mentions: 'Mentions',
  save: 'Save',
  deleteAccount: 'Delete Account',
  
  // Notification descriptions
  getNotifiedWhenSomeone: 'Get notified when someone',
  likesYourPosts: 'likes your posts',
  commentsOnYourPosts: 'comments on your posts',
  followsYou: 'follows you',
  mentionsYou: 'mentions you',
  sentYouMessage: 'sent you a message',
  chooseNotifications: 'Choose what notifications you want to receive',
  controlWhoInteracts: 'Control who can interact with you',
  manageAccountInfo: 'Manage your account information and preferences',
  emailCannotBeChanged: 'Email cannot be changed for security reasons',
  
  // Common
  loading: 'Loading...',
  cancel: 'Cancel',
  update: 'Update',
  submit: 'Submit',
  back: 'Back',
  next: 'Next',
  previous: 'Previous',
  online: 'Online',
  offline: 'Offline',
  unknownUser: 'Unknown User',
  
  // Profile
  editProfile: 'EDIT PROFILE',
  noBioYet: 'No bio yet.',
  followers: 'Followers',
  following: 'Following',
  recentActivity: 'Recent Activity',
  noPostsYet: 'No posts yet',
  shareFirstPost: 'Share your first post!',
  bio: 'Bio',
  dateOfBirth: 'Date of Birth',
  follow: 'Follow',
  unfollow: 'Unfollow',
  username: 'Username',
  yourPosts: 'Your Posts',
  
  // Search
  discover: 'Discover',
  findPeopleStories: 'Find people, stories, and ideas that matter to you',
  searchByName: 'Search by Name, Title, or #Tag...',
  searchResults: 'Search Results',
  noResultsFound: 'No results found',
  peopleFound: 'People Found',
  searchFunctionalityComingSoon: 'Search functionality coming soon...',
  
  // Settings - Additional keys
  enterDisplayName: 'Enter your display name',
  saving: 'Saving...',
  confirmDeleteAccount: 'Are you sure you want to delete your account? This cannot be undone.',
  accountDeletedSuccessfully: 'Account deleted successfully.',
  errorDeletingAccount: 'Error deleting account. Please try again.',
  settingsSavedSuccessfully: 'Settings saved successfully!',
  failedToSaveSettings: 'Failed to save settings. Please try again.',
  
  // Form component
  pleaseSignInToCreate: 'Please sign in to create a post.',
  titleRequired: 'Title is required to publish a post.',
  contentRequired: 'Story content is required to publish a post.',
  contentTooShort: 'Story content must be at least 10 characters long.',
  postUpdatedSuccessfully: 'Post updated successfully!',
  postPublishedSuccessfully: 'Post published successfully!',
  pleaseSignInToCreateBlogs: 'Please Sign In to create your own IdeaFlux blogs.',
  enterEngagingTitle: 'Enter an engaging title...',
  story: 'Story',
  writeYourMasterpiece: 'Write your masterpiece...',
  addTags: 'Add tags...',
  add: 'Add',
  publishPost: 'Publish Post',
  
  // Post component
  linkCopiedToClipboard: 'Link copied to clipboard! Share count updated.',
  youAndOthers: 'You and {{count}} others',
  noImage: 'No Image',
  deletePost: 'Delete Post',
  confirmDeletePost: 'Are you sure you want to delete this post?',
  
  // Email Verification
  verifyEmail: 'Verify Email',
  resendCode: 'Resend Code',
};